import { render } from "./TableContainerHeaderDashboard.vue?vue&type=template&id=6b8220eb&scoped=true"
import script from "./TableContainerHeaderDashboard.vue?vue&type=script&lang=js"
export * from "./TableContainerHeaderDashboard.vue?vue&type=script&lang=js"

import "./TableContainerHeaderDashboard.vue?vue&type=style&index=0&id=6b8220eb&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8220eb"]])

export default __exports__